
    import { total } from "./../helpers/node_gm_common"
    import { Getters } from "@/store/getters"
    import { defineComponent, PropType } from "vue"
    import List from "./misc/list/List.vue"
    import Category from "./Category.vue"
    import { mapActions, mapMutations } from "vuex"
    import { ICategory } from "@/types"

    export default defineComponent({
        props: {

        },
        components: {
            Category,
            List,

        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {

            }
        },
        computed: {
            totalCount(): number {
                return total(this.getters.categories?.map((category) => category.count) || [])
            },

            getters(): Getters {
                return this.$store.getters
            },
        },
        methods: {
            ...mapMutations(["SET_PROMPTS"]),
            select(item: ICategory) {
                !(+item.id === -1) && this.SET_PROMPTS([])
                this.$router.push(+item.id === -1 ? '/' : "/category/" + item.id)
            },

            ...mapActions(["delCategory", "editCategory", "addCategory"]),
            del(item: ICategory) {
                this.delCategory(item.id)
            },

            edit(item: ICategory, field: string, val: any) {
                this.editCategory({ _id: item.id, [field]: val })
            },

            add(name: string, pos: number) {
                this.addCategory({ name })
            },
        },
    })

    